import request from "./request.js";

export default {
  // 展示反馈
  showFeedbackList: (data) => {
    return request({
      url: "api/admin/feedback/showFeedbackList",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  // 更细反馈
  updateFeedback: (data) => {
    return request({
      url: "api/admin/feedback/updateFeedback",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  // 发送通知
  sendNotice: (data) => {
    return request({
      url: "api/admin/feedback/replyFeedback",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  // 赠送礼物
  giftScore: (data) => {
    return request({
      url: "api/admin/feedback/giftWordLimit",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
};
